<template>
    <div style="background-color: #fff;padding: 10px;border-radius: 10px;position: relative;min-height: 600px;">
        <!-- 加载状态遮罩层 -->
        <div class="loading-overlay" v-if="isLoading">
            <div class="loading-content">
                <i class="el-icon-loading loading-icon"></i>
                <span class="loading-text">加载中...</span>
            </div>
        </div>

        <!-- 主内容区域 -->
        <div class="main-content" :class="{ 'content-loading': isLoading }">
            <!-- 未登录时显示返回首页按钮 -->
            <div class="guest-header" v-if="!request_data.islogin">
                <button class="back-home-btn" @click="goToHome">
                    <i class="el-icon-back"></i>
                    <span>返回首页</span>
                </button>
            </div>

            <!-- 胶囊切换选择器 -->
            <div class="capsule-selector" v-if="request_data.data && request_data.data.vip_type">
                <div class="capsule-container">
                    <div v-for="(item, index) in request_data.data.vip_type" :key="item.key"
                        @click="select_vipkey(item.key, index)"
                        :class="['capsule-item', { active: selectedVipKey === item.key }]">
                        <div class="capsule-name">{{ item.name }}</div>
                        <div class="capsule-desc">{{ item.desc }}</div>
                    </div>
                </div>
            </div>

            <!-- VIP会员卡片区域 -->
            <div class="vip-cards-container" v-if="request_data.data && request_data.data[selectedVipKey] && !buying">
                <div class="vip-cards-grid">
                    <div v-for="(item, index) in request_data.data[selectedVipKey]" :key="item.id"
                        @click="vip_check = item"
                        :class="['vip-card', { 'selected': vip_check.id === item.id, 'popular': index === 1 }]">
                        <!-- 热销标签 -->
                        <div class="popular-badge" v-if="index === 1">
                            <span>热销</span>
                        </div>

                        <!-- 卡片头部 -->
                        <div class="card-header">
                            <div class="plan-icon">
                                <i class="el-icon-medal"></i>
                            </div>
                            <div class="plan-info">
                                <h3 class="plan-name">{{ item.name }}</h3>
                                <p class="plan-features">{{ item.huazhi }} · {{ item.surplus_info }}</p>
                            </div>
                        </div>

                        <!-- 价格区域 -->
                        <div class="price-section">
                            <div class="price-main">
                                <span class="currency">￥</span>
                                <span class="amount">{{ item.pay }}</span>
                                <span class="period">/{{ item.type == 1 ? '年' : item.surplus + '个月' }}</span>
                            </div>
                            <div class="price-daily">{{ item.ci2 }}</div>
                        </div>

                        <!-- 选中指示器 -->
                        <div class="selection-indicator" v-if="vip_check.id === item.id">
                            <i class="el-icon-check"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 会员权益：这 5 条在同组套餐里基本一致，只显示一份并跟随当前选中的套餐，
                 不再每张卡重复一遍。数据取 vip_check 而不是写死 —— 各套餐的 today
                 （每日额度）与 huazhi（超清/高清）并不相同，写死会张冠李戴。
                 区域标题右边标出当前是哪张卡，避免"看着是月卡的权益、其实选的是季卡"。 -->
            <div class="benefits-panel" v-if="vip_check.id && !buying">
                <div class="benefits-header">
                    <span class="benefits-title">会员权益</span>
                    <span class="benefits-plan">{{ vip_check.name }}</span>
                </div>
                <div class="features-list">
                    <div class="feature-item">
                        <i class="el-icon-check feature-icon supported"></i>
                        <span>每日{{ vip_check.today ? vip_check.today + '点' : '无限制' }}额度</span>
                    </div>
                    <div class="feature-item">
                        <i class="el-icon-check feature-icon supported"></i>
                        <span>{{ vip_check.huazhi }}画质支持</span>
                    </div>
                    <div class="feature-item">
                        <i
                            :class="vip_check.tuwen === '支持' ? 'el-icon-check feature-icon supported' : 'el-icon-close feature-icon unsupported'"></i>
                        <span>图文功能{{ vip_check.tuwen }}</span>
                    </div>
                    <div class="feature-item">
                        <i
                            :class="vip_check.haowu === '支持' ? 'el-icon-check feature-icon supported' : 'el-icon-close feature-icon unsupported'"></i>
                        <span>好物推荐{{ vip_check.haowu }}</span>
                    </div>
                    <div class="feature-item">
                        <i class="el-icon-check feature-icon supported"></i>
                        <span>解锁全模式</span>
                    </div>
                </div>
            </div>
            <!-- 未登录时的输入框 -->
            <div class="guest-input-section" v-if="!request_data.islogin && !buying">
                <div class="guest-input-container">
                    <div class="input-header">
                        <i class="el-icon-user"></i>
                        <span>请输入充值账户</span>
                    </div>
                    <el-input v-model="rechargeAccount" placeholder="请输入用户名或手机号" size="large" class="guest-input"
                        clearable @input="validateInput">
                    </el-input>
                    <div class="input-error" v-if="inputError">
                        <i class="el-icon-warning"></i>
                        <span>{{ inputError }}</span>
                    </div>
                </div>
            </div>

            <div v-if="request_data.islogin && !buying" class="balance-payment">
                <el-radio v-model="paymentMethod" label="alipay" :disabled="balancePayPending">
                    <span class="pay-opt">
                        <img class="pay-opt-icon pay-opt-icon--alipay" :src="require('@/assets/img/alipay.png')" alt="" />
                        <span class="pay-opt-label">支付宝支付</span>
                    </span>
                </el-radio>
                <!-- 微信扫码：手机端先下掉 —— Native 码在手机上根本走不通（微信禁止长按识别
                     与从相册识别，weixin:// 外部唤起也只把微信拉起来、进不去付款页），
                     手机上截图也扫不了。这里「先」是暂时的：要恢复手机端，删掉这个 v-if 即可，
                     下面的 qr-tappable / 点击唤起微信那套代码原样留着。 -->
                <el-radio v-if="!isMobile" v-model="paymentMethod" label="wechat" :disabled="balancePayPending">
                    <span class="pay-opt">
                        <img class="pay-opt-icon" :src="require('@/assets/img/wechat.svg')" alt="" />
                        <span class="pay-opt-label">微信支付（扫码）</span>
                    </span>
                </el-radio>
                <el-radio v-model="paymentMethod" label="balance" :disabled="!canBalancePay || balancePayPending">
                    <span class="pay-opt">
                        <i class="pay-opt-icon pay-opt-icon--balance el-icon-wallet"></i>
                        <span class="pay-opt-label">余额支付（¥{{ Number(user_balance || 0).toFixed(2) }}）</span>
                    </span>
                </el-radio>
            </div>
            <div class="purchase-section" v-if="!buying">
                <div class="purchase-button-container">
                    <div class="purchase-button-wrapper">
                        <button class="purchase-button" @click="buy(vip_check)"
                            :disabled="balancePayPending || !vip_check.id || (paymentMethod === 'balance' && !canBalancePay) || (request_data.islogin === 0 && (!rechargeAccount || inputError != ''))"
                            :class="{ 'disabled': !request_data.islogin && (!rechargeAccount || inputError != '') }">
                            <div class="button-background"></div>
                            <div class="button-content">
                                <i class="el-icon-s-finance button-icon"></i>
                                <span class="button-text">{{ '立即购买' }}</span>
                                <span class="button-price">￥{{ vip_check.pay }}</span>
                            </div>
                            <div class="button-shine"></div>
                        </button>
                        <!-- 支付提示悬浮到右上角 -->
                        <div class="payment-tooltip">
                            <i class="el-icon-info"></i>
                            <span>{{ paymentMethod === 'balance' ? '余额全额付款' : (paymentMethod === 'wechat' ? '支持微信扫码' : '支持支付宝') }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 服务条款提示语 -->
            <div class="terms-notice" v-if="!buying && request_data.data && request_data.data.bottom_text">
                <div class="terms-container">
                    <div class="terms-header">
                        <span class="terms-title">购买提示</span>
                    </div>
                    <div class="terms-content">
                        <div v-for="(text, index) in request_data.data.bottom_text" :key="index" class="terms-item">
                            <span class="terms-text">{{ text }}</span>
                        </div>
                    </div>

                    <!-- 分隔线 -->
                    <div class="section-divider"></div>

                    <!-- 协议同意声明 -->
                    <div class="agreement-section">
                        <span class="agreement-text">
                            购买{{ $siteConfig.siteName }}服务，即表示您同意我们的
                            <el-link type="primary" @click="sytk = true" class="agreement-link">《商业服务条款》</el-link>
                            和
                            <el-link type="primary" @click="yszc = true" class="agreement-link">《隐私协议》</el-link>
                        </span>
                    </div>
                </div>
            </div>

            <!-- 二维码支付弹窗 -->
            <div class="payment-modal-overlay" v-if="buying">
                <div class="payment-modal" @click.stop>
                    <!-- 支付弹窗头部 -->
                    <div class="payment-header">
                        <div class="payment-title">
                            <i class="el-icon-s-finance"></i>
                            <span>扫码支付</span>
                        </div>
                        <button class="close-button" @click="buy_out">
                            <i class="el-icon-close"></i>
                        </button>
                    </div>

                    <!-- 支付内容区域 -->
                    <div class="payment-content">
                        <!-- 商品信息 -->
                        <div class="product-info">
                            <div class="product-name">{{ vip_check.name }}</div>
                            <div class="product-price">￥{{ buying.pay }}</div>
                        </div>

                        <!-- 分隔线 -->
                        <div class="payment-divider"></div>

                        <!-- 二维码区域 -->
                        <div class="qr-section">
                            <div class="qr-container" :class="{ 'qr-tappable': canOpenInWechat }" @click="open_in_wechat">
                                <div id="qrcode" ref="qrcode" class="qr-code"></div>
                                <div class="qr-overlay" v-if="!qrCodeGenerated">
                                    <i class="el-icon-loading qr-loading"></i>
                                    <span>生成中...</span>
                                </div>
                            </div>

                            <!-- 支付方式提示 -->
                            <div class="payment-method">
                                <el-image v-if="payChannel === 'alipay'" class="payment-icon"
                                    :src="require('@/assets/img/alipay.png')"></el-image>
                                <img v-else class="payment-icon" :src="require('@/assets/img/wechat.svg')" alt="" />
                                <span class="payment-text">{{ payChannel === 'alipay' ? '使用支付宝扫码付款' : '使用微信扫码付款' }}</span>
                            </div>
                        </div>

                        <!-- 分隔线 -->
                        <div class="payment-divider"></div>

                        <!-- 操作按钮区域 -->
                        <div class="payment-actions">
                            <button class="action-button cancel-button" @click="buy_out">
                                <i class="el-icon-close"></i>
                                <span>取消支付</span>
                            </button>
                            <button class="action-button confirm-button" @click="buy_ok">
                                <i class="el-icon-check"></i>
                                <span>已完成支付</span>
                            </button>
                        </div>

                        <!-- 支付提示 -->
                        <div class="payment-tips">
                            <div class="tip-item">
                                <i class="el-icon-info"></i>
                                <span v-if="payChannel === 'wechat'">{{ wechatTips.pay }}</span>
                                <span v-else>请在新打开的支付页面完成付款</span>
                            </div>
                            <div class="tip-item">
                                <i class="el-icon-time"></i>
                                <span v-if="payChannel === 'wechat'">{{ wechatTips.after }}</span>
                                <span v-else>支付完成后请点击"已完成支付"按钮</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <el-dialog title="《商业服务条款》" :visible.sync="sytk" append-to-body custom-class="newdialog_share">
                <div style="height: 500px;">
                    <iframe src="../../../static/sytk.html" frameborder="0" style="width: 100%;height: 100%;"></iframe>
                </div>
            </el-dialog>
            <el-dialog title="《隐私协议》" :visible.sync="yszc" append-to-body custom-class="newdialog_share">
                <div style="height: 500px;">
                    <iframe src="../../../static/yszc.html" frameborder="0" style="width: 100%;height: 100%;"></iframe>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import QRCode from 'qrcodejs2'
export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            vip_list: [],
            buy_type: '月卡套餐',
            buying: false,
            ordernum: '',
            payChannel: 'alipay',  // 扫码弹窗当前渠道（alipay / wechat）
            qrTimer: null,  // 微信扫码查单轮询定时器
            qrCodeUrl: '',  // 微信 Native 的 code_url（weixin://...），手机端点二维码唤起微信用
            sytk: false,
            yszc: false,
            user_balance: 0,
            paymentMethod: 'alipay',
            balancePayPending: false,
            balanceRequest: null,
            vip_check: [],
            selectedVipKey: null,
            request_data: {},
            isLoading: true,  // 添加加载状态
            qrCodeGenerated: false,  // 二维码生成状态
            loadingTimer: null,  // 加载超时定时器
            // 充值相关
            rechargeAccount: '',  // 充值账号
            inputError: ''  // 输入错误信息
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
        canBalancePay() {
            return !!this.request_data.islogin && Number(this.vip_check.pay) > 0 && Number(this.user_balance) >= Number(this.vip_check.pay)
        },
        isMobile() {
            return /Mobile/i.test(navigator.userAgent)
        },
        // 微信内置浏览器：已经在微信里了，weixin:// 唤起没意义，靠长按识别二维码
        isWechatBrowser() {
            return /MicroMessenger/i.test(navigator.userAgent)
        },
        // 手机浏览器（微信外）点二维码尝试唤起微信。iOS 要求非 http scheme 的跳转发生在
        // 用户手势里，所以只能点击触发、不能自动跳；电脑端不给点（跳了也没用）。
        canOpenInWechat() {
            return this.isMobile && !this.isWechatBrowser && this.payChannel === 'wechat' && !!this.qrCodeUrl
        },
        // 微信渠道的提示语按打开环境分三种：微信内长按识别 / 微信外手机点击唤起 / 电脑扫码
        wechatTips() {
            const after = '支付成功后自动开通，无需再操作'
            if (this.isWechatBrowser) {
                return { pay: '长按下方二维码识别即可付款', after: after }
            }
            if (this.isMobile) {
                return { pay: '点击二维码可尝试唤起微信；不行就截图后用微信「扫一扫」', after: after }
            }
            return { pay: '请打开手机微信「扫一扫」完成付款', after: after }
        }
    },
    // 监控data中的数据变化
    watch: {
        canBalancePay(value) {
            if (!value) this.paymentMethod = 'alipay'
        }
    },
    // 方法集合
    methods: {
        cz_order() {
            this.$parent.$parent.$parent.vip = false
            this.$router.push('/user/info')

        },
        buy(item) {
            if (this.balancePayPending || !item.id) return
            if (this.paymentMethod === 'wechat') {
                this.buy_wx(item)
                return
            }
            if (this.paymentMethod !== 'balance') {
                this.buy_ma(item)
                return
            }
            if (!this.canBalancePay) {
                this.$msg.error('余额不足，需全额余额付款')
                return
            }
            this.balancePayPending = true
            this.$confirm('确认使用自己的账户余额全额支付 ' + item.pay + ' 元购买会员？', '余额支付', {
                confirmButtonText: '确认付款', cancelButtonText: '取消',
                type: 'warning', customClass: 'msbox'
            }).then(async () => {
                if (!this.balanceRequest || this.balanceRequest.id !== item.id || this.balanceRequest.expected_price !== item.pay) {
                    const bytes = new Uint8Array(16)
                    window.crypto.getRandomValues(bytes)
                    const key = Array.from(bytes).map(value => ('0' + value.toString(16)).slice(-2)).join('')
                    this.balanceRequest = { id: item.id, expected_price: item.pay, request_id: key }
                }
                try {
                    const res = await this.$ajax.post('api/v1/users/pay/balance-pay', this.balanceRequest)
                    if (res.data.status == 200) {
                        this.user_balance = res.data.balance
                        this.balanceRequest = null
                        this.$msg.success(res.data.msg)
                        this.vip_list_fc()
                    } else {
                        this.balanceRequest = null
                        this.$msg.error(res.data.msg)
                    }
                } catch (error) {
                    this.$msg.error('支付结果未确认，请重试，重复请求不会重复扣款')
                }
            }).catch(() => {}).finally(() => {
                this.balancePayPending = false
            })
        },
        // 支付宝扫码：新后端自己向支付宝当面付下单（不再走 pay.siyoa.com 收银台），
        // qr_code 是 https://qr.alipay.com/... —— 电脑端画成二维码，手机端直接跳过去唤起支付宝。
        // 免登录代充与老 PHP 同口径：传了充值账号就按账号充，没传才用当前登录用户。
        buy_ma(item) {
            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post('api/v1/users/pay/alipay/vip-order', {
                id: item.id,
                username: this.rechargeAccount || ''
            }).then(res => {
                loading.close();
                var jg = res.data;
                if (jg.status == 200) {
                    this.payChannel = 'alipay';
                    this.buying = item;
                    this.ordernum = jg.ordernum;
                    if (this.isMobile) {
                        window.location.href = jg.qr_code;
                        return;
                    }
                    this.$nextTick(() => {
                        this.qrcode(jg.qr_code);
                    });
                } else {
                    this.$toast.show(jg.msg, 3000);
                }
            }).catch(() => {
                loading.close();
                this.$msg.error('下单失败，请稍后重试');
            })
        },
        // 微信 Native 扫码：新后端下单拿 code_url 画二维码，支付成功后由微信回调开通会员，
        // 所以这里只管展示 + 盯订单状态（老 PHP 收银台那条链路不参与）。
        buy_wx(item) {
            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post('api/v1/users/pay/native-pay', { id: item.id }).then(res => {
                loading.close();
                var jg = res.data;
                if (jg.status == 200) {
                    this.payChannel = 'wechat';
                    this.qrCodeUrl = jg.data.code_url;
                    this.buying = item;
                    this.ordernum = jg.ordernum;
                    this.$nextTick(() => {
                        this.qrcode(jg.data.code_url);
                    });
                    this.start_qr_poll();
                } else {
                    this.$toast.show(jg.msg, 3000);
                }
            }).catch(() => {
                loading.close();
                this.$msg.error('下单失败，请稍后重试');
            })
        },
        buy_ok() {
            this.check_paid(false);
        },
        // 手机浏览器里点二维码，用 weixin:// scheme 尝试唤起微信。
        // 微信官方不支持这种用法（Native 的定义就是「把码给用户扫」），成不成看机型；
        // 所以它只是兜底，失败了还有提示语里的「截图后用微信扫一扫」。
        open_in_wechat() {
            if (!this.canOpenInWechat) return;
            window.location.href = this.qrCodeUrl;
        },
        poll_paid() {
            if (!this.buying || !this.ordernum) return;
            this.check_paid(true);
        },
        // 查单：老 PHP 的 payok 与新后端共用 yh_order_new 一张表，所以微信单同样查得到
        check_paid(silent) {
            var data = { ordernum: this.ordernum }
            this.$ajax.post('qhy/user/payok', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                if (res.data.status == 200) {
                    this.stop_qr_poll();
                    this.$msg.success(res.data.msg)
                    this.buying = false
                    this.ordernum = ''
                    this.$parent.$parent.$parent.vip = false
                } else if (!silent) {
                    this.$msg.error(res.data.msg)
                }
            })
        },
        start_qr_poll() {
            this.stop_qr_poll();
            this.qrTimer = setInterval(this.poll_paid, 3000);
        },
        stop_qr_poll() {
            if (this.qrTimer) {
                clearInterval(this.qrTimer);
                this.qrTimer = null;
            }
        },
        buy_out() {
            this.stop_qr_poll();
            this.qrCodeUrl = '';
            this.buying = false
            this.ordernum = ''
            this.qrCodeGenerated = false
            // 清理二维码
            if (this.qrcode_m) {
                this.qrcode_m.clear()
                this.qrcode_m = null
            }
        },
        closePaymentModal(event) {
            // 点击遮罩层关闭弹窗
            if (event.target.classList.contains('payment-modal-overlay')) {
                this.buy_out()
            }
        },
        qrcode(url) {
            this.qrCodeGenerated = false
            // 清理之前的二维码
            if (this.qrcode_m) {
                this.qrcode_m.clear()
            }

            // 延迟一下生成二维码，保证DOM已渲染
            setTimeout(() => {
                try {
                    this.qrcode_m = new QRCode("qrcode", {
                        // 按 2 倍分辨率绘制：显示尺寸交给 CSS（.qr-code）控制，各端可自由缩放。
                        // 原来是「绘制尺寸 = 显示尺寸 = 180」，手机上缩到 148 就等于把 180 的
                        // 位图放大，明显发虚；改成画 360 再按 CSS 缩下来，高分屏也清晰。
                        width: 360,
                        height: 360,
                        text: url,
                        colorDark: "#000000",
                        colorLight: "#ffffff",
                        correctLevel: QRCode.CorrectLevel.H
                    })
                    this.qrCodeGenerated = true
                } catch (error) {
                    console.error('二维码生成失败:', error)
                    this.qrCodeGenerated = true // 即使失败也隐藏加载状态
                }
            }, 100)
        },

        buy_type_fc() {
            console.log(this.buy_type)
            this.vip_list_fc()
        },
        vip_list_fc(type = '') {
            // 开始加载
            this.isLoading = true;
            // 清除之前的定时器
            if (this.loadingTimer) {
                clearTimeout(this.loadingTimer);
            }

            // 设置10秒超时
            this.loadingTimer = setTimeout(() => {
                if (this.isLoading) {
                    this.isLoading = false;
                    this.$message.warning('加载超时，请检查网络后重试');
                    console.warn('加载超时: 10秒内未收到响应');
                }
            }, 10000); // 10秒超时

            if (type == '') {
                type = this.buy_type
            }
            var data = { 'type': type }
            this.$ajax.post('qhy/app/app_ios_pay2', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                // 清除超时定时器
                if (this.loadingTimer) {
                    clearTimeout(this.loadingTimer);
                    this.loadingTimer = null;
                }

                console.log(res.data)
                var jg = res.data

                if (res.data.status == 200) {
                    this.vip_list = jg.data
                    this.vip_check = this.vip_list[0]
                    this.request_data = res.data
                    if (jg.islogin) {
                        this.$ajax.get('api/v1/users/me').then(res => {
                            this.user_balance = res.data.balance || 0
                        }).catch(() => {
                            this.$msg.error('获取账户余额失败，请刷新后重试')
                        })
                    }

                    // 初始化选中第一个类型
                    if (this.request_data.data && this.request_data.data.vip_type && this.request_data.data.vip_type.length > 0) {
                        this.selectedVipKey = this.request_data.data.vip_type[0].key
                        // 初始化选中第一个会员卡片
                        if (this.selectedVipKey && this.request_data.data[this.selectedVipKey] && this.request_data.data[this.selectedVipKey].length > 0) {
                            this.vip_check = this.request_data.data[this.selectedVipKey][0]
                        }
                    }
                }
                // 加载完成，隐藏加载状态
                this.isLoading = false;

            }).catch(error => {
                // 清除超时定时器
                if (this.loadingTimer) {
                    clearTimeout(this.loadingTimer);
                    this.loadingTimer = null;
                }

                // 加载失败也要隐藏加载状态
                this.isLoading = false;
                console.error('加载数据失败:', error);
                this.$message.error('加载数据失败，请重试');
            })
        },

        // 选择VIP类型
        select_vipkey(key, index) {
            this.selectedVipKey = key
            // 每次切换类型时自动选中第一个会员卡片
            if (this.request_data.data && this.request_data.data[key] && this.request_data.data[key].length > 0) {
                this.vip_check = this.request_data.data[key][0]
            }
        },

        // 验证输入
        validateInput() {
            const account = this.rechargeAccount.trim()

            if (!account) {
                this.inputError = ''
                return
            }

            // 手机号验证
            const phoneRegex = /^1[3-9]\d{9}$/
            // 用户名验证（允许字母、数字、下划线，4-20位）
            const usernameRegex = /^[a-zA-Z0-9_]{4,20}$/

            if (!phoneRegex.test(account) && !usernameRegex.test(account)) {
                this.inputError = '请输入正确的手机号或用户名（4-20位字母数字下划线）'
            } else {
                this.inputError = ''
            }
        },

        // 返回首页
        goToHome() {
            this.$router.push('/')
        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        if (this.vip_list.length < 1) {
            this.vip_list_fc()
        }
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // this.vip_list_fc()
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() {
        // 清理定时器，防止内存泄漏
        if (this.loadingTimer) {
            clearTimeout(this.loadingTimer);
            this.loadingTimer = null;
        }
        this.stop_qr_poll();
    }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style>
.balance-payment { margin: 20px 0; text-align: center; }
.balance-payment p { color: #909399; font-size: 12px; line-height: 1.6; }
.balance-payment .el-radio { margin-top: 10px; }

/* 支付方式选项：图标 + 文字（2.0 页在 User2/Vip.vue 里再细化尺寸与选中色） */
.pay-opt {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    vertical-align: middle;
}

.pay-opt-icon {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 5px;
    object-fit: contain;
}

/* 支付宝/微信各有品牌 logo 图，余额没有，用 Element 的钱包图标当裸图标（2.0 页换主色） */
.pay-opt-icon--balance {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 19px;
    color: #3239a9;
}

.pay-opt-label { line-height: 1.4; }

/* 支付弹窗样式 */
.payment-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    animation: fadeIn 0.3s ease;
}

.payment-modal {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
    border-radius: 20px;
    box-shadow: 0 20px 60px rgba(50, 57, 169, 0.15);
    border: 1px solid rgba(50, 57, 169, 0.1);
    max-width: 480px;
    width: 90%;
    max-height: 90vh;
    overflow: hidden;
    animation: slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    backdrop-filter: blur(20px);
}

/* 弹窗头部 */
.payment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #3239a9 0%, #4a50c7 100%);
    color: white;
    position: relative;
}

.payment-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 18px;
    font-weight: 600;
}

.payment-title i {
    font-size: 20px;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
}

.close-button {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    backdrop-filter: blur(10px);
}

.close-button:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

/* 支付内容区域 */
.payment-content {
    padding: 24px;
}

/* 商品信息 */
.product-info {
    text-align: center;
    padding: 6px 0;
}

.product-name {
    font-size: 18px;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 8px;
}

.product-price {
    font-size: 32px;
    font-weight: 800;
    color: #3239a9;
    text-shadow: 0 1px 2px rgba(50, 57, 169, 0.1);
}

/* 分隔线 */
.payment-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, rgba(50, 57, 169, 0.15) 50%, transparent 100%);
    margin: 20px 0;
}

/* 二维码区域 */
.qr-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.qr-container {
    position: relative;
    background: white;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 4px 20px rgba(50, 57, 169, 0.1);
    border: 1px solid rgba(50, 57, 169, 0.1);
}

.qr-code {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 180px;
    height: 180px;
}

/* qrcodejs2 动态插入的 canvas/img 没有尺寸约束，会按绘制分辨率（360）撑开，
   统一让它们填满 .qr-code —— 显示尺寸就由各端 CSS 决定（2.0 页在 User2/Vip.vue 里覆盖） */
.qr-code canvas,
.qr-code img {
    width: 100%;
    height: 100%;
}

/* 手机浏览器（微信外）里二维码可点，用来尝试唤起微信 —— 给个可点的视觉暗示 */
.qr-tappable {
    cursor: pointer;
    border-color: rgba(7, 193, 96, 0.45);
    box-shadow: 0 4px 20px rgba(7, 193, 96, 0.18);
}

.qr-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    backdrop-filter: blur(4px);
}

.qr-loading {
    font-size: 24px;
    color: #3239a9;
    animation: rotate 1.5s linear infinite;
}

/* 支付方式提示 */
.payment-method {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: rgba(50, 57, 169, 0.05);
    border-radius: 8px;
    border: 1px solid rgba(50, 57, 169, 0.1);
}

.payment-icon {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    object-fit: contain;
}

.payment-text {
    font-size: 14px;
    color: #4a5568;
    font-weight: 500;
}

/* 操作按钮区域 */
.payment-actions {
    display: flex;
    gap: 12px;
    margin: 8px 0;
}

.action-button {
    flex: 1;
    height: 52px;
    border: none;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 52px;
}

.cancel-button {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
    border: 1px solid rgba(239, 68, 68, 0.2);
}

.cancel-button:hover {
    background: rgba(239, 68, 68, 0.15);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

.confirm-button {
    background: linear-gradient(135deg, #3239a9 0%, #4a50c7 100%);
    color: white;
    box-shadow: 0 4px 20px rgba(50, 57, 169, 0.3);
}

.confirm-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 25px rgba(50, 57, 169, 0.4);
}

.action-button:active {
    transform: translateY(0);
}

/* 支付提示 */
.payment-tips {
    margin-top: 16px;
    padding: 16px;
    background: rgba(16, 185, 129, 0.05);
    border-radius: 8px;
    border: 1px solid rgba(16, 185, 129, 0.1);
}

.tip-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 13px;
    color: #4a5568;
    line-height: 1.4;
}

.tip-item:last-child {
    margin-bottom: 0;
}

.tip-item i {
    color: #10b981;
    margin-top: 2px;
    flex-shrink: 0;
}

/* 动画 */
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px) scale(0.9);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* 响应式适配 */
@media (max-width: 768px) {
    .payment-modal {
        width: 92%;
        margin: 16px;
    }

    .payment-content {
        padding: 22px;
    }

    .product-price {
        font-size: 30px;
    }

    .qr-code {
        width: 170px;
        height: 170px;
    }

    .action-button {
        height: 52px;
        font-size: 15px;
    }
}

@media (max-width: 480px) {
    .payment-modal {
        width: 95%;
        margin: 20px;
    }

    .payment-content {
        padding: 20px;
    }

    .product-price {
        font-size: 28px;
    }

    .qr-code {
        width: 160px;
        height: 160px;
    }

    .payment-actions {
        flex-direction: column;
        gap: 14px;
    }

    .action-button {
        height: 50px;
        font-size: 15px;
        font-weight: 600;
    }
}

/* 超小屏幕适配 */
@media (max-width: 360px) {
    .payment-modal {
        width: 96%;
        margin: 16px;
    }

    .payment-content {
        padding: 18px;
    }

    .action-button {
        height: 48px;
        font-size: 14px;
    }
}

/* 访客输入区域样式 */
.guest-header {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
    padding: 10px 0;
}

.back-home-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    background: linear-gradient(135deg, rgba(50, 57, 169, 0.1) 0%, rgba(255, 255, 255, 0.8) 100%);
    border: 1px solid rgba(50, 57, 169, 0.2);
    border-radius: 20px;
    color: #3239a9;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 8px rgba(50, 57, 169, 0.1);
}

.back-home-btn:hover {
    background: linear-gradient(135deg, rgba(50, 57, 169, 0.15) 0%, rgba(255, 255, 255, 0.9) 100%);
    border-color: rgba(50, 57, 169, 0.3);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(50, 57, 169, 0.15);
}

.back-home-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(50, 57, 169, 0.2);
}

.back-home-btn i {
    font-size: 16px;
    color: #3239a9;
    filter: drop-shadow(0 1px 2px rgba(50, 57, 169, 0.1));
}

.back-home-btn span {
    color: #3239a9;
    text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

.guest-input-section {
    margin: 20px 0;
    display: flex;
    justify-content: center;
    padding: 0 20px;
}

.guest-input-container {
    max-width: 400px;
    width: 100%;
    background: linear-gradient(135deg, rgba(50, 57, 169, 0.05) 0%, rgba(255, 255, 255, 0.8) 100%);
    border: 1px solid rgba(50, 57, 169, 0.15);
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(50, 57, 169, 0.08);
    backdrop-filter: blur(10px);
}

.input-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    color: #3239a9;
    font-weight: 600;
    font-size: 15px;
    justify-content: center;
}

.input-header i {
    margin-right: 8px;
    font-size: 18px;
    filter: drop-shadow(0 1px 2px rgba(50, 57, 169, 0.2));
}

.guest-input {
    width: 100%;
    margin-bottom: 8px;
}

.guest-input .el-input__inner {
    height: 48px;
    border-radius: 12px;
    border: 2px solid rgba(50, 57, 169, 0.15);
    background: rgba(248, 249, 255, 0.9);
    font-size: 15px;
    transition: all 0.3s ease;
}

.guest-input .el-input__inner:focus {
    border-color: #3239a9;
    background: white;
    box-shadow: 0 0 0 3px rgba(50, 57, 169, 0.1);
}

.input-error {
    display: flex;
    align-items: center;
    margin-top: 6px;
    color: #ef4444;
    font-size: 12px;
    gap: 4px;
    justify-content: center;
}

.input-error i {
    font-size: 14px;
    flex-shrink: 0;
}

/* 购买按钮禁用状态 */
.purchase-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: 0 2px 10px rgba(50, 57, 169, 0.15) !important;
}

.purchase-button.disabled:hover {
    transform: none !important;
    box-shadow: 0 2px 10px rgba(50, 57, 169, 0.15) !important;
}

/* 响应式适配 */
@media (max-width: 768px) {
    .guest-header {
        margin-bottom: 15px;
        padding: 8px 0;
    }

    .back-home-btn {
        padding: 6px 12px;
        font-size: 13px;
    }

    .back-home-btn i {
        font-size: 14px;
    }

    .guest-input-section {
        margin: 15px 0;
        padding: 0 15px;
    }

    .guest-input-container {
        padding: 16px;
    }

    .guest-input .el-input__inner {
        height: 46px;
        font-size: 14px;
    }

    .input-header {
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .guest-header {
        margin-bottom: 12px;
        padding: 6px 0;
    }

    .back-home-btn {
        padding: 5px 10px;
        font-size: 12px;
        gap: 4px;
    }

    .back-home-btn i {
        font-size: 13px;
    }

    .guest-input-section {
        margin: 12px 0;
        padding: 0 10px;
    }

    .guest-input-container {
        padding: 14px;
    }

    .guest-input .el-input__inner {
        height: 44px;
        font-size: 14px;
    }

    .input-header {
        font-size: 13px;
    }

    .input-error {
        font-size: 11px;
    }
}

/* 加载状态样式 */
.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(248, 249, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 100%);
    backdrop-filter: blur(8px);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    transition: opacity 0.3s ease;
}

.loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 30px;
    background: linear-gradient(135deg, rgba(50, 57, 169, 0.08) 0%, rgba(255, 255, 255, 0.6) 100%);
    border-radius: 16px;
    border: 1px solid rgba(50, 57, 169, 0.15);
    box-shadow: 0 8px 32px rgba(50, 57, 169, 0.12);
    backdrop-filter: blur(12px);
    min-width: 200px;
    min-height: 120px;
    max-width: 300px;
    text-align: center;
}

.loading-icon {
    font-size: 32px;
    color: #3239a9;
    animation: rotate 1.5s linear infinite;
    filter: drop-shadow(0 2px 4px rgba(50, 57, 169, 0.2));
}

.loading-text {
    font-size: 14px;
    color: #4a5568;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* 主内容区域 */
.main-content {
    transition: opacity 0.3s ease;
}

.main-content.content-loading {
    opacity: 0.1;
    pointer-events: none;
    filter: blur(1px);
}

.xz {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}

.xz .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #3239a9;
    border-color: #3239a9;
    box-shadow: -1px 0 0 0 #3239a9;
}

.xz .el-radio-group {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.xz .el-radio-button__inner {
    border-left: 1px solid #DCDFE6;
    margin: 5px 0px;
}

.xz .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0px;
}

.tc_item {
    border-radius: 10px;
    margin: 6px;
    width: 30%;
    min-width: 100%;
    position: relative;
    background-color: #f5f5f5;
    border: 0px;
    padding: 20px 0px;
}



/* 胶囊切换选择器样式 */
.capsule-selector {
    margin: 20px 0;
    display: flex;
    justify-content: center;
    padding: 0 10px;
}

.capsule-container {
    position: relative;
    display: flex;
    background: rgba(50, 57, 169, 0.1);
    border-radius: 50px;
    padding: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(50, 57, 169, 0.2);
    overflow-x: auto;
    /* 使用width 100%配合min-width和max-width实现响应式 */
    width: 100%;
    min-width: 300px;
    max-width: 600px;
    /* 防止换行 */
    flex-wrap: nowrap;
    /* 隐藏滚动条但保持滚动功能 */
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.capsule-container::-webkit-scrollbar {
    display: none;
}

.capsule-item {
    position: relative;
    z-index: 2;
    padding: 10px 20px;
    margin: 0 2px;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-align: center;
    user-select: none;
    /* 桌面端也使用均匀分配宽度 */
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* 默认状态样式 */
    background: transparent;
    color: #3239a9;
}

.capsule-item:hover {
    transform: translateY(-1px);
}

.capsule-item.active {
    /* 选中状态使用CSS背景效果 */
    background: linear-gradient(135deg, #3239a9 0%, #4a50c7 100%);
    color: white;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 8px rgba(50, 57, 169, 0.3);
}

.capsule-name {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 2px;
    line-height: 1.2;
}

.capsule-desc {
    font-size: 11px;
    opacity: 0.8;
    line-height: 1.2;
}

.capsule-item:not(.active) .capsule-desc {
    color: #666;
}

/* VIP会员卡片样式 */
.vip-cards-container {
    margin: 40px 0;
    display: flex;
    justify-content: center;
}

.vip-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    gap: 16px;
    max-width: 900px;
    width: 100%;
}

.vip-card {
    position: relative;
    background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
    border: 2px solid #e8ecf4;
    border-radius: 16px;
    padding: 18px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(50, 57, 169, 0.08);
}

.vip-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(50, 57, 169, 0.15);
    border-color: #3239a9;
}

.vip-card.selected {
    background: linear-gradient(135deg, #3239a9 0%, #4a50c7 100%);
    border-color: #3239a9;
    color: white;
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(50, 57, 169, 0.3);
}

.vip-card.popular {
    border-color: #ff6b6b;
    /* 移除泛红背景，保持与普通卡片一致 */
    background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
}

.vip-card.popular.selected {
    /* 选中时使用统一的蓝色风格，不使用红色 */
    background: linear-gradient(135deg, #3239a9 0%, #4a50c7 100%);
    border-color: #3239a9;
}

.popular-badge {
    position: absolute;
    top: -2px;
    right: 20px;
    background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
    color: white;
    padding: 6px 16px;
    border-radius: 0 0 12px 12px;
    font-size: 12px;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

.card-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.plan-icon {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #3239a9 0%, #4a50c7 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    transition: all 0.3s ease;
}

.vip-card.selected .plan-icon {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
}

.plan-icon i {
    font-size: 20px;
    color: white;
}

.plan-info {
    flex: 1;
}

.plan-name {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 4px 0;
    color: #2d3748;
}

.vip-card.selected .plan-name {
    color: white;
}

.plan-features {
    font-size: 13px;
    color: #718096;
    margin: 0;
}

.vip-card.selected .plan-features {
    color: rgba(255, 255, 255, 0.8);
}

.price-section {
    text-align: center;
    margin: 18px 0;
    padding: 16px;
    background: rgba(50, 57, 169, 0.05);
    border-radius: 12px;
    transition: all 0.3s ease;
}

.vip-card.selected .price-section {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
}

.price-main {
    display: flex;
    align-items: baseline;
    justify-content: center;
    margin-bottom: 6px;
}

.currency {
    font-size: 18px;
    font-weight: 600;
    color: #3239a9;
    margin-right: 2px;
}

.vip-card.selected .currency {
    color: white;
}

.amount {
    font-size: 30px;
    font-weight: 800;
    color: #3239a9;
    line-height: 1;
}

.vip-card.selected .amount {
    color: white;
}

.period {
    font-size: 14px;
    color: #718096;
    margin-left: 2px;
}

.vip-card.selected .period {
    color: rgba(255, 255, 255, 0.8);
}

.price-daily {
    font-size: 13px;
    color: #718096;
    font-weight: 500;
}

.vip-card.selected .price-daily {
    color: rgba(255, 255, 255, 0.7);
}

/* 会员权益区：5 条特性只显示一份、跟随选中套餐（2.0 页在 User2/Vip.vue 里细化） */
.benefits-panel {
    margin: 20px 0;
    padding: 16px;
    border: 1px solid rgba(50, 57, 169, 0.12);
    border-radius: 12px;
    background: #f8f9ff;
    text-align: left;
}

.benefits-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
}

.benefits-title {
    font-size: 14px;
    font-weight: 600;
    color: #2d3748;
}

.benefits-plan {
    font-size: 12px;
    color: #718096;
}

.features-list {
    margin: 6px 0;
}

.feature-item {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    padding: 6px 0;
}

.feature-icon {
    width: 16px;
    height: 16px;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    font-size: 9px;
    flex-shrink: 0;
}

.feature-icon.supported {
    background: #10b981;
    display: flex;
}

.feature-icon.unsupported {
    background: #ef4444;
    display: flex;
}

.vip-card.selected .feature-icon.supported {
    background: #10b981;
    display: flex;
}

.vip-card.selected .feature-icon.unsupported {
    background: #ef4444;
    display: flex;
}

.feature-item span {
    font-size: 13px;
    color: #4a5568;
    line-height: 1.4;
}

.vip-card.selected .feature-item span {
    color: rgba(255, 255, 255, 0.9);
}

.selection-indicator {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 30px;
    height: 30px;
    background: #10b981;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 16px;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
    animation: checkmark 0.3s ease;
}

@keyframes checkmark {
    0% {
        transform: scale(0);
        opacity: 0;
    }

    50% {
        transform: scale(1.1);
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

/* 响应式适配 */
@media (max-width: 768px) {
    .vip-cards-grid {
        /* 手机端显示两列 */
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
        padding: 0 8px;
    }

    .vip-card {
        padding: 14px;
    }

    .plan-name {
        font-size: 15px;
    }

    .amount {
        font-size: 26px;
    }

    .feature-item span {
        font-size: 12px;
    }

    .price-section {
        margin: 14px 0;
        padding: 14px;
    }
}

@media (max-width: 480px) {
    .vip-cards-grid {
        /* 超小屏幕仍然保持两列，但缩小间距 */
        gap: 6px;
        padding: 0 4px;
    }

    .vip-card {
        padding: 10px;
    }

    .card-header {
        margin-bottom: 10px;
    }

    .plan-icon {
        width: 32px;
        height: 32px;
        margin-right: 8px;
    }

    .plan-icon i {
        font-size: 16px;
    }

    .plan-name {
        font-size: 13px;
    }

    .amount {
        font-size: 22px;
    }

    .feature-item span {
        font-size: 11px;
    }

    .price-section {
        margin: 12px 0;
        padding: 12px;
    }

    .feature-item {
        margin-bottom: 6px;
        padding: 4px 0;
    }
}

/* 支付按钮样式 */
.purchase-section {
    margin: 15px 0 20px 0;
    display: flex;
    justify-content: center;
    width: 100%;
}

.purchase-button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.purchase-button-wrapper {
    position: relative;
    display: inline-block;
}

.purchase-button {
    position: relative;
    width: 280px;
    height: 56px;
    border: none;
    border-radius: 28px;
    background: linear-gradient(135deg, #3239a9 0%, #4a50c7 50%, #5b5fcf 100%);
    color: white;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 20px rgba(50, 57, 169, 0.3),
        0 0 0 1px rgba(255, 255, 255, 0.1) inset;
    backdrop-filter: blur(10px);
}

/* 支付提示悬浮样式 */
.payment-tooltip {
    position: absolute;
    top: -10px;
    right: -10px;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: #4a5568;
    background: rgba(255, 255, 255, 0.95);
    padding: 6px 10px;
    border-radius: 16px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(50, 57, 169, 0.15);
    box-shadow: 0 2px 12px rgba(50, 57, 169, 0.1);
    white-space: nowrap;
    z-index: 10;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.payment-tooltip i {
    font-size: 12px;
    color: #3239a9;
    filter: drop-shadow(0 1px 2px rgba(50, 57, 169, 0.2));
}

.payment-tooltip span {
    font-weight: 500;
    line-height: 1.2;
}

/* 跟随主按钮动画 */
.purchase-button-wrapper:hover .payment-tooltip {
    transform: translateY(-2px);
}

.purchase-button:active~.payment-tooltip {
    transform: translateY(0);
}

.purchase-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(50, 57, 169, 0.4),
        0 0 0 1px rgba(255, 255, 255, 0.2) inset;
}

.purchase-button:active {
    transform: translateY(0);
    box-shadow: 0 4px 20px rgba(50, 57, 169, 0.5);
}

.button-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0.05) 50%,
            transparent 100%);
    border-radius: 28px;
}

.button-content {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 8px;
}

.button-icon {
    font-size: 18px;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
}

.button-text {
    font-size: 16px;
    letter-spacing: 0.5px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.button-price {
    font-size: 18px;
    font-weight: 700;
    margin-left: 4px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.button-shine {
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg,
            transparent 30%,
            rgba(255, 255, 255, 0.3) 50%,
            transparent 70%);
    transform: translateX(-100%);
    transition: transform 0.6s ease;
}

.purchase-button:hover .button-shine {
    transform: translateX(100%);
}

/* 服务条款提示语样式 */
.terms-notice {
    margin: 20px 0 15px 0;
    display: flex;
    justify-content: center;
    padding: 0 10px;
    width: 100%;
}

.terms-container {
    max-width: 900px;
    width: 100%;
    background: linear-gradient(135deg, rgba(50, 57, 169, 0.03) 0%, rgba(255, 255, 255, 0.8) 100%);
    border: 1px solid rgba(50, 57, 169, 0.1);
    border-radius: 12px;
    padding: 12px 16px;
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 12px rgba(50, 57, 169, 0.05);
    margin: 0 auto;
}

.terms-header {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    padding-bottom: 6px;
    border-bottom: 1px solid rgba(50, 57, 169, 0.08);
}

.terms-title {
    font-size: 14px;
    font-weight: 600;
    color: #2d3748;
    letter-spacing: 0.3px;
}

.terms-content {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.terms-item {
    display: flex;
    align-items: flex-start;
    padding: 4px 0;
    flex: 1;
    min-width: calc(50% - 3px);
}


.terms-text {
    font-size: 13px;
    line-height: 1.3;
    color: #4a5568;
    text-align: left;
    word-break: break-word;
}

/* 小屏幕单列布局 */
@media (max-width: 500px) {
    .terms-item {
        min-width: 100%;
    }
}

/* 分隔线样式 */
.section-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, rgba(50, 57, 169, 0.2) 50%, transparent 100%);
    margin: 12px 0;
}

/* 协议同意区域 */
.agreement-section {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    text-align: center;
    margin-top: 8px;
}

.agreement-icon {
    font-size: 14px;
    color: #3239a9;
    margin-top: 2px;
    flex-shrink: 0;
    filter: drop-shadow(0 1px 2px rgba(50, 57, 169, 0.2));
}

.agreement-text {
    font-size: 14px;
    line-height: 1.5;
    color: #4a5568;
    word-break: break-word;
}

.agreement-link {
    font-size: 14px !important;
    font-weight: 600;
    color: #3239a9 !important;
    text-decoration: none;
    position: relative;
    transition: all 0.2s ease;
}

.agreement-link:hover {
    color: #4a50c7 !important;
    text-shadow: 0 1px 2px rgba(50, 57, 169, 0.2);
}

.agreement-link::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 0;
    height: 1px;
    background: linear-gradient(90deg, #3239a9, #4a50c7);
    transition: width 0.3s ease;
}

.agreement-link:hover::after {
    width: 100%;
}

/* 协议区域响应式适配 */
@media (max-width: 500px) {
    .agreement-text {
        font-size: 12px;
    }

    .agreement-link {
        font-size: 12px !important;
    }

    .agreement-icon {
        font-size: 12px;
    }

    .section-divider {
        margin: 10px 0;
    }
}

/* 响应式适配 */
@media (max-width: 768px) {
    .purchase-button {
        width: 240px;
        height: 52px;
        font-size: 15px;
    }

    .button-text {
        font-size: 15px;
    }

    .button-price {
        font-size: 16px;
    }

    .payment-tooltip {
        font-size: 10px;
        padding: 5px 8px;
        top: -6px;
        right: -8px;
    }

    .payment-tooltip i {
        font-size: 11px;
    }
}

@media (max-width: 480px) {
    .purchase-button {
        width: 220px;
        height: 50px;
    }

    .button-content {
        gap: 6px;
    }

    .payment-tooltip {
        font-size: 9px;
        padding: 4px 6px;
        top: -5px;
        right: -6px;
    }

    .payment-tooltip i {
        font-size: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/User/Vip.vue



// WEBPACK FOOTER //
// src/components/User/Vip.vue